// validators.ts
import { object, oneOf, optional, string } from "justus";
var EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/;
var PHONE_REGEXP = /^\+[1-9]\d{5,14}$/;
var b2bRegistrationValidator = object({
  email: string({ pattern: EMAIL_REGEXP }),
  first_name: string({ minLength: 1, maxLength: 64 }),
  last_name: string({ minLength: 1, maxLength: 64 }),
  company_name: string({ minLength: 1, maxLength: 64 }),
  phone_number: optional(string({ pattern: PHONE_REGEXP })),
  employee_count: optional(string({ minLength: 1, maxLength: 64 })),
  contact_type: oneOf("freezer", "gastro", "retail", "other"),
  customer_message: optional(string({ maxLength: 250 })),
  language: optional(oneOf("en", "de"), "de")
});
export {
  b2bRegistrationValidator
};
//# sourceMappingURL=validators.mjs.map
